/* MORÉVA — interactions */
(function(){
  var head=document.querySelector('.site-head');
  function onScroll(){ if(!head) return; if(window.scrollY>40) head.classList.add('solid'); else head.classList.remove('solid'); }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  var h=document.querySelector('.hero'); if(h){ requestAnimationFrame(function(){h.classList.add('in');}); }

  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});

  var burger=document.querySelector('.burger'), mnav=document.querySelector('.mobile-nav'), mclose=document.querySelector('.m-close');
  if(burger&&mnav){ burger.addEventListener('click',function(){mnav.classList.add('open');document.body.style.overflow='hidden';}); }
  if(mclose&&mnav){ mclose.addEventListener('click',function(){mnav.classList.remove('open');document.body.style.overflow='';}); }
  document.querySelectorAll('.mobile-nav a').forEach(function(a){a.addEventListener('click',function(){if(mnav){mnav.classList.remove('open');document.body.style.overflow='';}});});

  document.querySelectorAll('.nl-form').forEach(function(f){
    f.addEventListener('submit',function(ev){ev.preventDefault();var t=f.parentNode.querySelector('.nl-thanks');if(t)t.style.display='block';f.style.display='none';});
  });

  document.querySelectorAll('.qty').forEach(function(q){
    var input=q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){ var v=parseInt(input.value||'1',10); v+=(b.dataset.dir==='up'?1:-1); if(v<1)v=1; input.value=v; });
    });
  });

  // add to cart -> real Shopify cart permalink
  document.querySelectorAll('[data-add]').forEach(function(b){
    b.addEventListener('click',function(ev){
      ev.preventDefault();
      var v=b.getAttribute('data-variant'); var q=1;
      var box=b.closest('.buy'); if(box){var qi=box.querySelector('.qty input'); if(qi){q=parseInt(qi.value||'1',10)||1;}}
      if(v){ b.textContent='Taking you to checkout…'; window.location.href='https://morevastore.com/cart/'+v+':'+q; return; }
      document.querySelectorAll('.cart-count').forEach(function(c){var n=parseInt(c.textContent.replace(/\D/g,'')||'0',10)+1;c.textContent='('+n+')';});
    });
  });

  document.querySelectorAll('.pdp-thumbs img').forEach(function(t){
    t.addEventListener('click',function(){ var wrap=document.querySelector('.pdp-main'); var main=wrap?wrap.querySelector('img'):null; if(main&&t.dataset.full){ main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src=t.dataset.full; if(t.dataset.zoom==='0'){wrap.classList.add('no-zoom');}else{wrap.classList.remove('no-zoom');} document.querySelectorAll('.pdp-thumbs img').forEach(function(x){x.classList.remove('is-active');}); t.classList.add('is-active'); } });
  });

  // contact form -> mailto
  var cf=document.querySelector('.contact-form');
  if(cf){ cf.addEventListener('submit',function(ev){ ev.preventDefault();
    function val(n){var el=cf.querySelector('[name='+n+']');return el?el.value:'';}
    var body=encodeURIComponent('Name: '+val('name')+'\nEmail: '+val('email')+'\n\n'+val('message'));
    var t=cf.querySelector('.nl-thanks'); if(t)t.style.display='block';
    window.location.href='mailto:contact@morevastore.com?subject='+encodeURIComponent('Moreva enquiry')+'&body='+body;
  });}
})();
